var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaderRibbon = function SvgLeaderRibbon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Assets",
    width: 32.5,
    height: 42.47,
    preserveAspectRatio: "none",
    viewBox: "0 0 32.5 42.47"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffce41}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58 27.87h1.33l2.18 4.53 5.39-2.89 5.39 2.11 2.81-3.75 5.15 11.95-6.17-1.72-3.04 4.37-4.06-9.37-3.2 6.87-3.75-3.9-5.78 2.26z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m29.68 15.07 2.03-5-3.83-1.95-.62-4.53h-5.47L18.59 0l-4.14 2.03L9.61.39 7.97 4.37l-5 .86 1.41 3.75-4.45 1.95 3.67 3.83-3.67 4.91L5.08 21l-.31 4.84h4.61l2.03 3.67 4.76-2.42 5.39 2.42 2.73-4.29 4.14.94v-5l3.98-1.8zM16.17 22.8a8.04 8.04 0 1 1 0-16.08 8.04 8.04 0 0 1 0 16.08",
    className: "cls-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.56 11.01 1.88 1.64 2.1-1.64.63 8.04h-2.66l.36 2.03h5.89l.62-2.42h-2.49l.39-10.31h-2.74z",
    className: "cls-1"
  })));
};
export default SvgLeaderRibbon;